import { useMemo } from 'react';
import { PriorityLevel } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { HighPriority, LowPriority, MediumPriority } from '@sib/ui/icons';

export const usePriorityOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('enums.Priority.low'),
        textClassname: 'text-info',
        value: PriorityLevel.Low,
        className: 'data-[state=on]:bg-info ',
        icon: <LowPriority />,
      },
      {
        label: t('enums.Priority.medium'),
        textClassname: 'text-warning',
        value: PriorityLevel.Medium,
        className: 'data-[state=on]:bg-warning ',
        icon: <MediumPriority />,
      },
      {
        label: t('enums.Priority.high'),
        textClassname: 'text-accent-pink',
        value: PriorityLevel.High,
        className: 'data-[state=on]:bg-accent-pink',
        icon: <HighPriority />,
      },
    ],
    [t]
  );
};
